import React from 'react'
import { RegistrationForm } from '@/components/composed/RegistrationForm'
import { FundingBannerFormWrapper } from '../FundingBannerFormWrapper'
import { messages } from './messages'
import type { TFundingBannerConsultingRegistrationFormProps } from './types'
import './styles.scss'

export const FundingBannerConsultingRegistrationForm = ({
  phoneNumber,
  onGoBack,
  onRegistrationComplete,
  loanAmount,
}: TFundingBannerConsultingRegistrationFormProps) => {
  const handleRegistrationComplete = () => {
    onRegistrationComplete(phoneNumber, loanAmount)
  }

  return (
    <FundingBannerFormWrapper>
      <RegistrationForm
        className="fundingBannerConsultingRegistrationForm"
        headerClassName="fundingBannerConsultingRegistrationForm__header"
        titleClassName="h2 fundingBannerConsultingRegistrationForm__title"
        formClassName="fundingBannerConsultingRegistrationForm__form"
        fieldsClassName="fundingBannerConsultingRegistrationForm__fields"
        phoneNumberClassName="fundingBannerConsultingRegistrationForm__phoneNumber"
        checkboxesClassName="fundingBannerConsultingRegistrationForm__checkboxes"
        buttonsClassName="fundingBannerConsultingRegistrationForm__buttons"
        goBack={onGoBack}
        phoneNumber={phoneNumber}
        afterRegistrationComplete={handleRegistrationComplete}
        submitButtonText={messages.submitButton}
        goBackButtonModifiers={['outline-gray']}
        submitButtonModifiers={['green']}
        fullNameFieldModifiers={['white']}
        organizationProfileFieldModifiers={['white']}
        emailFieldModifiers={['white']}
        shouldSkipSelectRoleStep
      />
    </FundingBannerFormWrapper>
  )
}
